/*******************************************************************************
 * @ngdoc    object
 * @module   csm.books.InitialSetup.services
 * @name     csm.books.InitialSetup.services.Data.type:SetupAccount
 * @constructor
 * @param {object=} info  Item info read from database.
 * @description
 * Account Information for Initial Setup.
 *******************************************************************************/
/* @ngInject */ export function setupDataConfig(TypeFactoryProvider) {
  var defaults = {
    org: null, // Organization Information
    accounts: [], // List of <b>SetupAccount</b> objects
    entries: [] // List of <b>SetupJournal</b> entries to open the books. Output only.
  };

  TypeFactoryProvider.addType({
    name: 'Data.SetupData',
    $type: 'csm.books.data.setup.SetupData, CSMBooks',
    constructor: function (Data) {
      return function (data) {
        this.defaultConstructor(Object.assign({}, defaults, data));
        this.org = new Data.books.entities.Organization(this.org);
        this.accounts = this.accounts.map(function (a) {
          return Data.SetupAccount.newInstance(a);
        });
      };
    }
  });
}
